import { useSelector } from "react-redux"
import { staticComponentValueConverter } from "../StaticComponentValues";
import { useState } from "react";



const ProductDetailAttributes_1 = ({ item }) => {
    const customization = staticComponentValueConverter(item?.customization);
    const disabledAttributes = customization?.disabledAttributes
    const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
    const attributes = selectedProduct?.data?.attributes
    return (<>
        {attributes?.length > 0 ? <div className="flex flex-col">
            {attributes?.map((attribute, index) => {
                const type = attribute?.productAttribute?.type
                const id = attribute?.productAttribute?.id
                const ActiveType = types[type]
                if (!ActiveType || disabledAttributes?.includes(id)) return <></>

                return <ActiveType customization={customization} attribute={attribute} index={index} />
            })}
        </div> :

            <img src={item?.placeholderImage} className={` w-full `} />}
    </>
    )
}

const HTML = ({ index, attribute, customization }) => {

    const [isOpen, setIsOpen] = useState(false)
    return (

        <div className="px-[10px]"
            style={{
                backgroundColor: '#F8F8F8',
            }}>
            <div className="flex p-[15px]"

                style={{
                    flexDirection: 'row',

                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderTopWidth: index !== 0 && 1,
                    borderTopColor: '#F4F4F4',
                }}>
                <div>{attribute?.productAttribute?.name}</div>
                <div style={{ transform: isOpen ? "rotate(90deg)" : "rotate(-90deg)" }} onClick={() => { setIsOpen(state => !state) }} >

                    <svg

                        width={24}
                        height={24}
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M31 36L19 24L31 12"
                            stroke="#000000"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
            {isOpen && <div className="w-full text-start" dangerouslySetInnerHTML={{ __html: attribute?.value }} >

            </div>}
        </div>
    )
}

const types = {
    HTML
}

export default ProductDetailAttributes_1